<!-- eslint-disable max-len -->
<template>
  <div>
    <h5
      v-if="!isLoading && !forCanvas"
      class="mb-2"
    >
      {{ dataComponent.name }}
    </h5>

    <div v-if="!isLoading">
      <!-- Summary Block Non Workflow -->
      <div
        v-if="type === 'default' && detailComponent.summary_block"
        class="wrap-summary-block"
      >
        <div class="d-flex">
          <div
            v-for="(data, index) in detailComponent.summary_block"
            :key="index"
            :style="styleDivBlock(data)"
            class="container-summary-block"
          >
            <div class="item-name">{{ data.name }}</div>
            <div class="item-count">0</div>
          </div>
        </div>
      </div>

      <!-- Summary Block Workflow -->
      <div
        v-else-if="type !== 'default' && detailComponent.summary_block"
        class="wrap-summary-block"
      >
        <div class="d-flex">
          <div
            v-for="(data, index) in detailComponent.summary_block"
            :key="index"
            :style="setStyleSummary(data.color, index)"
            :class="setClassSummary(data.type)"
            class="container-summary-block"
          >
            <div class="item-name">{{ data.name }}</div>
            <div class="item-count">0</div>
          </div>
        </div>
      </div>

      <!-- Column -->
      <div class="mt-3">
        <!-- Button -->
        <div class="d-flex align-items-center mb-2">
          <b-button
            class="btn grey btn-import-form m__r--5"
            disabled
          >
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-button
            v-if="type === 'default'"
            class="btn grey btn-import-form m__r--5"
            disabled
          >
            <i class="fa fa-cloud-upload fa-lg"/> Import
          </b-button>
          <b-button
            v-if="type === 'default'"
            class="btn grey btn-import-form m__r--5"
            disabled
          >
            <i class="fa fa-download fa-lg"/> Export
          </b-button>
          <b-button
            class="btn grey btn-import-form"
            disabled
          >
            <i class="fa fa-filter fa-lg"/> Filter
          </b-button>
        </div>

        <div
          v-if="detailComponent.columns && detailComponent.columns.length > 0"
          class="columns"
        >
          <div class="d-flex align-items-center">
            <div
              v-for="(data, index) in detailComponent.columns"
              :key="index"
              class="column"
            >
              <div
                class="header-list"
                style="cursor: default !important;"
              >
                <img :src="require(`@/assets/icon/column-type/${setIconType(data.type)}.svg`)">
                <div class="separator" />
                <div class="column-name">
                  {{ data.name }}
                </div>
              </div>
              <div
                v-for="index in 4"
                :key="index"
                :class="{'bg-gray': index === 2 || index === 4}"
                class="column-preview"
                style="cursor: default !important;"
              >
                <div class="content-preview"/>
              </div>
            </div>
          </div>
        </div>

        <p
          v-if="!detailComponent.columns || detailComponent.columns.length === 0"
          class="text-empty-data-component"
        >
          No Column On This Component
        </p>
      </div>
    </div>

    <div
      v-else
      class="skeleton-component"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import jMixComponentMultiDetailView from '@/mixins/form-ui-v2/jMixComponentMultiDetailView';

export default {
  mixins: [jMixComponentMultiDetailView],

  props: {
    type: {
      type: String,
      default: 'default',
    },
    forCanvas: {
      type: Boolean,
      default: false,
    },
    forDetailParent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // Default summary block
      defaultSummaryBlockRequester: [
        {
          key: 'draft',
          name: 'Draft',
          color: '#808285',
          type: 'first_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'sent',
          name: 'Sent',
          color: '#F36F21',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'approved',
          name: 'Approved',
          color: '#42A5CE',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'closed',
          name: 'Closed',
          color: '#0C9C68',
          type: 'last_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'rejected',
          name: 'Rejected',
          color: '#8A0D4F',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'canceled',
          name: 'Canceled',
          color: '#4D3923',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
      ],
      defaultSummaryBlockApprover: [
        {
          key: 'sent',
          name: 'Sent',
          color: '#F36F21',
          type: 'first_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'approved_by_me',
          name: 'Approved By Me',
          color: '#42A5CE',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'approved',
          name: 'Approved',
          color: '#42A5CE',
          type: 'last_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'rejected',
          name: 'rejected',
          color: '#8A0D4F',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
      ],
    };
  },

  methods: {
    async getDetailComponent() {
      const response = await this.requestDataComponent();
      if (response) {
        switch (this.type) {
          case 'requestor':
            this.detailComponent = response.data.data[0].table_requester_view;
            break;
          case 'approver':
            this.detailComponent = response.data.data[0].table_approver_view;
            break;
          default:
            this.detailComponent = this.forCanvas ?
              response.data[0].table_view :
              response.data.data[0].table_view;
            break;
        }
        if (this.type !== 'default') this.setDataSummaryBlockWorkflow();
        this.isLoading = false;
      }
    },

    setDataSummaryBlockWorkflow() {
      if (this.type === 'requestor') {
        if (!this.detailComponent.summary_block) this.detailComponent.summary_block = this.defaultSummaryBlockRequester;
      } else if (this.type === 'approver') {
        if (!this.detailComponent.summary_block) this.detailComponent.summary_block = this.defaultSummaryBlockApprover;
      }
    },

    styleDivBlock(item) {
      return { '--color': item.color };
    },

    setClassSummary(type) {
      let blockClass = '';
      switch (type) {
        case 'first_block':
          blockClass = 'sum-start';
          break;
        case 'middle_block':
          blockClass = 'sum-middle';
          break;
        case 'last_block':
          blockClass = 'sum-last';
          break;
        case 'block':
          blockClass = 'sum-alone-last';
          break;
        default:
          blockClass = 'sum-alone-last';
          break;
      }
      return blockClass;
    },

    setStyleSummary(color, index) {
      const styleColor = `--color:${color};`;
      const styleMargin = this.setStyleMargin(index);

      return `${styleColor}${styleMargin}`;
    },

    setStyleMargin(index) {
      const data = this.detailComponent.summary_block;
      const lastBlock = this.type === 'requestor' ? 2 : 1;

      let style = 'margin-left: 0px';
      if (index > 0) {
        const type = data[index].type;
        const blockBefore = data[index - 1].type;

        if (type === 'first_block') {
          if (blockBefore === 'first_block' || blockBefore === 'middle_block') {
            if ((index + 1) !== (data.length - lastBlock)) {
              style = 'margin-left: 27px';
            } else if ((index + 1) === (data.length - lastBlock)) {
              style = 'margin-left: 27px; margin-right: 33px';
            }
          } else if (blockBefore === 'last_block') {
            if ((index + 1) === (data.length - lastBlock)) {
              style = 'margin-right: 33px';
            }
          }
        } else if (type === 'middle_block') {
          if ((index + 1) === (data.length - lastBlock)) {
            style = 'margin-right: 33px';
          }
        }
      }

      return style;
    },

    setIconType(type) {
      const convertType = type.toLowerCase();
      let finalType = '';
      if (convertType === 'date' || convertType === 'mmmm dd, yyyy' || convertType === 'MMMM dd, yyyy' || convertType === 'dd-mmm-yyyy') {
        finalType = 'date';
      } else {
        finalType = convertType;
      }
      return finalType;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dummy/DummyTableView.vue